var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427321643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-1--pin-push-thumbtack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 48",
    d: "M11.6001 8.12203C11.6432 8.01731 11.7206 7.93034 11.8196 7.87534L14.0872 6.61554C14.3776 6.45421 14.4329 6.0598 14.198 5.8249L10.4687 2.09567C10.2338 1.86078 9.83944 1.91602 9.67811 2.2064L8.41831 4.47404C8.36331 4.57304 8.27633 4.65044 8.17161 4.69356L3.36014 6.67473C3.03022 6.81057 2.94467 7.23833 3.19696 7.49062L8.80297 13.0966C9.05525 13.3489 9.48301 13.2634 9.61886 12.9335L11.6001 8.12203Z",
    stroke: "#C4CDD5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M1.33325 14.9596L5.99992 10.293",
    stroke: "#C4CDD5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDefault);
export default __webpack_public_path__ + "static/media/pin-default.c5c117c4d40992d64467db367c570c42.svg";
export { ForwardRef as ReactComponent };